import React from 'react';
import CommonImage, {formatImageCMSData} from "@/components/common/Image";
import styled from "styled-components";

const Image = styled(CommonImage)`
    animation: fade-in var(--local-duration) var(--ease);
	width: 100%;
	&.image {
		height: 100%;
	}
	
	&.illustration {
		height: auto;
    	aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
	}
`
const SlideImage = ({ data, className='', ...props }) => {
	const image = formatImageCMSData(data?.thumbnail?.image)
	return (
		<Image
			key={image.url}
			src={image.url}
			alt={image.alt}
			$aspectRatio={image.aspectRatio}
			className={`${className}`}
			placeholder={image.placeholder}
			{...props}
		/>
	);
};

export default SlideImage;
